import { RuleHelpers } from './RuleHelpers.js';

/**
 * Create rule helpers instance
 */
export function createRuleHelpers() {
  return new RuleHelpers();
}

// Export the class for advanced usage
export { RuleHelpers } from './RuleHelpers.js';
